/*
 *
 * IntermediateShelfPanel reducer
 *
 */

import ActionTypes from './constants';
import { ContainerState, ContainerActions } from './types';

export const initialState: ContainerState = {
  isVisible: false,
  selectedLevelIS: [],
};

function intermediateShelfPanelReducer(
  state: ContainerState = initialState,
  action: ContainerActions,
): ContainerState {
  switch (action.type) {
    case ActionTypes.DISPLAY_INTERMEDIATE_SHELF_PANEL:
      if (!action.payload.value) {
        return { ...state, isVisible: false, selectedLevelIS: [] };
      }
      return { ...state, isVisible: action.payload.value };
    case ActionTypes.SELECTION_INTERMEDIATE_SHELVES:
      let selection = action.payload.values;
      if (!selection) {
        selection = [0];
      }
      return { ...state, selectedLevelIS: selection };
    default:
      return state;
  }
}

export default intermediateShelfPanelReducer;
